import script from "./Step2SellerCreation.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2SellerCreation.vue?vue&type=script&setup=true&lang=js"

import "./Step2SellerCreation.vue?vue&type=style&index=0&id=5adac0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adac0bc"]])

export default __exports__